import { FAKE, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { GenericStorefrontAPIRequest, StorefrontApiResponse } from 'components/discovery/shared/ecommerce-api-token/api/ecommerce-api-token-api.js'
import type { PdpProduct } from 'components/discovery/pdp/typing/pdp-product.js'

export const PDP_PRODUCT_API = Symbol('PDP_PRODUCT_API')

export class GetPdpProductRequest extends GenericStorefrontAPIRequest { }

export interface PdpProductAPI {
  getProduct(request: GetPdpProductRequest): StorefrontApiResponse<PdpProduct>
}

@registerDependency(FAKE, PDP_PRODUCT_API)
export class FakePdpProductAPI implements PdpProductAPI {
  productRequests: GetPdpProductRequest[] = []
  productData: PdpProduct | null = null

  getProduct(request: GetPdpProductRequest): Promise<PdpProduct> {
    this.productRequests.push(request)
    return Promise.resolve(this.productData as PdpProduct)
  }
}

@registerDependency(REAL, PDP_PRODUCT_API)
export class RealPdpProductAPI implements PdpProductAPI {
  async getProduct(request: GetPdpProductRequest): Promise<PdpProduct> {
    const response = await fetch(request.endpointUrl, {
      method: request.method,
      headers: request.headers,
    })
    return await response.json() as PdpProduct
  }
}
